<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
        <wcinput :option="{placeholder:'选择私信会员',clearable:true,ischange:true,width:'200px',isinput:true,iskeydown:true}" 
            :value="memberinfo.name"
            @click="searchMember('member')"
            @finish="(val)=> {
                memberinfo.name=val.value;
                param.ischange=true;
                GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'选择接收私信会员',clearable:true,ischange:true,width:'200px',isinput:true,iskeydown:true}" 
            :value="tomemberinfo.name"
            @click="searchMember('tomember')"
            @finish="(val)=> {
                tomemberinfo.name=val.value;
                param.ischange=true;
                GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'私信内容',clearable:true,ischange:true,width:'200px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item>
        <wcbutton 
            :option="{title:'重置',type:'del'}" 
            @finish="(val)=> {
                memberinfo.id=0;
                memberinfo.name='';
                tomemberinfo.id=0;
                tomemberinfo.name='';
                param.memberid='';
                param.tomemberid='';
                param.key='';
                param.ischange=true;
                GetList();
            }"
        />
        </el-form-item>
    </el-form>
</div>


<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column prop="membername" label="私信发起人" align="center"/>
        <el-table-column prop="tomembername" label="私信接收人" align="center"/>
        <el-table-column label="私信内容" align="center">
            <template #default="scope">
                <div class="content-box">{{scope.row.content}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="inputtime" label="时间" align="center"/>
        <el-table-column label="操作" align="center">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'删除',type:'del'}" @finish="delletter(scope.row.id)" class="left10"/>
            </div>
            </template>
        </el-table-column>
        
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>



</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';
export default {

    components:{
        
    },

    data() {
        return {
            objloading:'comment',
            param: {
                key:'',
                memberid:'',
                tomemberid:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },

            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
            ],
            
            //私信发起人
            memberinfo: {
                id:'',
                name:'',
            },
            //私信接收人
            tomemberinfo: {
                id:'',
                name:''
            },
            membertype:'',

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                if(data.param.type=='selectmember' && this.membertype=='member') {
                    this.memberinfo.id=data.param.data.id;
                    this.memberinfo.name=data.param.data.name;
                    this.param.memberid=this.memberinfo.id;
                    this.param.ischange=true;
                }else if(data.param.type=='selectmember' && this.membertype=='tomember') {
                    this.tomemberinfo.id=data.param.data.id;
                    this.tomemberinfo.name=data.param.data.name;
                    this.param.tomemberid=this.tomemberinfo.id;
                    this.param.ischange=true;
                }
                this.GetList();
                
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }

        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_GOODS.GET_LETTER_LIST(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 删除商品信息 **/
        delletter(id) {
            INTERFACE_MODEL_GOODS.DEL_LETTER({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },

        
        /** 搜索商品 **/
        searchMember(type) {
            this.membertype=type;
            this.$parent.JUMPVIEW({name:'EsMembers',param:{childtype:'selectmember',rollbackobjname:'EsLetter'}})
        },

    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.content-box {display: inline-block;width:100%;font-size:13px;}
.content-box span {color:#666eeb;margin-right:10px;}
</style>